import React from 'react';
import PropTypes from 'prop-types';
import './MediaAnnotationPanel.scss';

/**
 * MediaAnnotationPanel component for displaying media annotations
 * Shows in a modal overlay with image on left, text on right
 * Used for displaying product information with images and descriptions
 * 
 * @param {Object} annotation - The selected annotation object with media data
 * @param {Function} onClose - Callback when panel is closed
 */
const MediaAnnotationPanel = ({ annotation, onClose }) => {
  if (!annotation || !annotation.mediaData) return null;

  const { title, mediaData } = annotation;
  const { lines = [] } = mediaData;

  return (
    <div className="media-annotation-panel">
      <div className="media-annotation-panel__overlay" onClick={onClose} />
      
      <div className="media-annotation-panel__modal">
        <div className="media-annotation-panel__header">
          <div className="media-annotation-panel__title-section">
            <h3 className="media-annotation-panel__title">{title}</h3>
          </div>
          <button
            className="media-annotation-panel__close-btn"
            onClick={onClose}
            aria-label="Close media panel"
          >
            ✕
          </button>
        </div>

        <div className="media-annotation-panel__content">
          <div className="media-annotation-panel__text-section">
            <ul className="media-annotation-panel__text-list">
              {lines.map((line, idx) => (
                <li key={idx} className="media-annotation-panel__text-line">
                  {line}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

MediaAnnotationPanel.propTypes = {
  annotation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    mediaData: PropTypes.shape({
      title: PropTypes.string,
      lines: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
  }),
  onClose: PropTypes.func.isRequired,
};

export default MediaAnnotationPanel;
